export default __webpack_public_path__ + "static/media/badeti-dharma.210355d4.png";